import { unsupported } from '../errors'
import { holderTraveler } from '../reserva/holder'
import type { GuestProfile, NoticesStay, NotificacionesService, SaveDataConsent } from './types'


/**
 * Titular con lo que da E1 (D23): el adulto registrado que no se puede borrar (`adult && !canDelete`). E1 no tiene móvil del titular.
 * Antes del registro no hay datos: null.
 */
export function holderProfile(stay: Pick<NoticesStay, 'registration'>): GuestProfile {
  const holder = holderTraveler(stay)
  if (!holder) return { name: null, email: null, phone: null }
  const name = [holder.name, holder.surname].filter(Boolean).join(' ').trim()
  return { name: name || null, email: holder.details.email, phone: null }
}

const PENDING: SaveDataConsent = { status: 'pending_confirmation', recordedAt: null, textVersion: null }

export const notificacionesReal: NotificacionesService = {
  // Avisos enviados y preferencias: no existen en la API actual. Guardar preferencias solo en el dispositivo no
  // evitaría que llegaran los mensajes, así que no se guardan (D53).
  list: unsupported,
  getPreferences: unsupported,
  setPreference: unsupported,
  getProfile(stay) {
    return Promise.resolve(holderProfile(stay))
  },
  // El consentimiento de guardar datos solo cuenta si lo registra el backend (D53, como D37).
  getSaveDataConsent() {
    return Promise.resolve(PENDING)
  },
  setSaveDataConsent: unsupported,
  getDataRequests: unsupported,
  requestExport: unsupported,
  requestDeletion: unsupported,
}
